import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1E3C72',
        secondary: '#00695C',
        accent: '#7C4DFF',
        success: '#2E7D32',
        warning: '#F9A825',
        error: '#C62828',
        info: '#0277BD',
      },
    },
  },
});
